namespace TabAurous.OMS {
    export interface CurrencyMasterForm {
        CurrencySymbol: Serenity.StringEditor;
        CurrencyName: Serenity.StringEditor;
        SubunitName: Serenity.StringEditor;
        NoOfDecimalPlaces: Serenity.IntegerEditor;
        ExtraDate: Serenity.DateEditor;
        IsDefault: Serenity.BooleanEditor;
        Narration: Serenity.TextAreaEditor;
    }

    export class CurrencyMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CurrencyMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CurrencyMasterForm.init)  {
                CurrencyMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.TextAreaEditor;

                Q.initFormType(CurrencyMasterForm, [
                    'CurrencySymbol', w0,
                    'CurrencyName', w0,
                    'SubunitName', w0,
                    'NoOfDecimalPlaces', w1,
                    'ExtraDate', w2,
                    'IsDefault', w3,
                    'Narration', w4
                ]);
            }
        }
    }
}
